import {
  AdobeTracking,
  ComponentTrackingPath,
  handleRocheTeaserClick,
  OnSiteSearch,
  SearchTrackingData,
} from '@repo/roche-xx-shared';
import { MouseEvent } from 'react';

export enum SearchTrackingType {
  MEDIA_RELEASES = 'Media Releases Search',
  INVESTOR_UPDATES = 'Investor Updates Search',
  AD_HOC = 'Ad Hoc Search',
  MEDIA_EVENTS = 'Media Events Search',
  INVESTOR_EVENTS = 'Investor Events Search',
  PUB_MED = 'Pub Med Search',
  MAIN_SEARCH = 'Main Search',
  SEARCH_SUGGESTION = 'Search Suggestion',
}

export const trackSearchEvent = (
  trackingData: Omit<OnSiteSearch, 'searchComponent'>,
  searchType: SearchTrackingType,
) => {
  const data: OnSiteSearch = {
    ...trackingData,
    searchComponent: searchType.toString(),
  } as OnSiteSearch;

  AdobeTracking(data, 'onsiteSearch');
};

export const trackSearchItemClickEvent = (
  event: MouseEvent,
  trackingData: SearchTrackingData,
  title: string,
  url: string,
  path: ComponentTrackingPath,
) => {
  handleRocheTeaserClick({
    event: event,
    teaserTitle: title,
    teaserUrl: url,
    componentPath: path,
    searchTrackingData: trackingData,
  });
};
